<div class="page-content">
    <div class="container-fluid">
        <p>icon works!</p>
    </div>
</div>